import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  activationProductApi,
  deleteFileApi,
  deleteProductApi,
  getAllProductApi,
  getAllSellerProductApi,
  getSingleProductApi,
  multipleFileUploadApi,
  updateColorApi,
  updateProductApi,
  updateSizeApi,
  uploadColorApi,
  uploadProductApi,
  uploadSizeApi,
} from "../api/ProductApi";

const initialState = {
  products: {},
  singleProduct: {},
  productVariants: [],
  imageFileResponse: [],
  videoFileResponse: [],
  productResponse: {},
  colorResponse: {},
  sizeResponse: {},
  filters: {},
  keyword: "",
  sku: "",
  sortdir: "",
  sortby: "",
  editProduct: {
    isEdit: false,
    body: {},
  },

  stepper: 1,
  categoryType: "",

  isVideo: false,

  loading: false,
  deleting: false,
  fileUploading: false,
  uploading: false,
};

export const multipleImageUpload = createAsyncThunk(
  "product/multipleImageUpload",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await multipleFileUploadApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const deleteSingleImage = createAsyncThunk(
  "product/deleteSingleImage",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await deleteFileApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const multipleVideoUpload = createAsyncThunk(
  "product/multipleVideoUpload",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await multipleFileUploadApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const deleteSingleVideo = createAsyncThunk(
  "product/deleteSingleVideo",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await deleteFileApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const getAllProduct = createAsyncThunk(
  "product/getAllProduct",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getAllProductApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const getAllSellerProduct = createAsyncThunk(
  "product/getAllSellerProduct",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getAllSellerProductApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const getSingleProduct = createAsyncThunk(
  "product/getSingleProduct",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getSingleProductApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const uploadProduct = createAsyncThunk(
  "product/uploadProduct",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await uploadProductApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const updateProduct = createAsyncThunk(
  "product/updateProduct",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await updateProductApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const deleteProduct = createAsyncThunk(
  "product/deleteProduct",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await deleteProductApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const activationProduct = createAsyncThunk(
  "product/activationProduct",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await activationProductApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const uploadColor = createAsyncThunk(
  "product/uploadColor",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await uploadColorApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const updateColor = createAsyncThunk(
  "product/updateColor",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await updateColorApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const uploadSize = createAsyncThunk(
  "product/uploadSize",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await uploadSizeApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const updateSize = createAsyncThunk(
  "product/updateSize",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await updateSizeApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

const productSlice = createSlice({
  name: "product",
  initialState,
  reducers: {
    addKeywordSearch: (state, action) => {
      state.keyword = action.payload;
    },
    addSku: (state, action) => {
      state.sku = action.payload;
    },
    addSortDir: (state, action) => {
      state.sortdir = action.payload;
    },
    addSortBy: (state, action) => {
      state.sortby = action.payload;
    },
    clearAllFilter: (state, action) => {
      state.keyword = "";
      state.sortby = "";
      state.sortdir = "";
    },
    setEditProduct: (state, action) => {
      state.editProduct = {
        isEdit: action.payload.isEdit,
        body: action.payload.body,
      };
    },
    setStepper: (state, action) => {
      state.stepper = action.payload;
    },
    setIsVideo: (state, action) => {
      state.isVideo = action.payload;
    },
    setCategoryType: (state, action) => {
      state.categoryType = action.payload;
    },
    setProductVariants: (state, action) => {
      state.productVariants = action?.payload || [];
    },
  },
  extraReducers: (builder) => {
    // upload images
    builder.addCase(multipleImageUpload.pending, (state) => {
      state.fileUploading = true;
    });
    builder.addCase(multipleImageUpload.fulfilled, (state, action) => {
      state.imageFileResponse = action.payload?.response;
      state.isVideo = false;
      state.fileUploading = false;
    });
    builder.addCase(multipleImageUpload.rejected, (state) => {
      state.fileUploading = false;
      state.isVideo = false;
    });

    // delete images
    builder.addCase(deleteSingleImage.pending, (state) => {
      state.fileUploading = true;
    });
    builder.addCase(deleteSingleImage.fulfilled, (state, action) => {
      state.imageFileResponse = action.payload?.response;
      state.isVideo = false;
      state.fileUploading = false;
    });
    builder.addCase(deleteSingleImage.rejected, (state) => {
      state.fileUploading = false;
      state.isVideo = false;
    });

    // upload videos
    builder.addCase(multipleVideoUpload.pending, (state) => {
      state.fileUploading = true;
    });
    builder.addCase(multipleVideoUpload.fulfilled, (state, action) => {
      state.videoFileResponse = action.payload?.response;
      state.isVideo = false;
      state.fileUploading = false;
    });
    builder.addCase(multipleVideoUpload.rejected, (state) => {
      state.fileUploading = false;
    });

    // delete images
    builder.addCase(deleteSingleVideo.pending, (state) => {
      state.fileUploading = true;
    });
    builder.addCase(deleteSingleVideo.fulfilled, (state, action) => {
      state.videoFileResponse = action.payload?.response;
      state.isVideo = false;
      state.fileUploading = false;
    });
    builder.addCase(deleteSingleVideo.rejected, (state) => {
      state.fileUploading = false;
      state.isVideo = false;
    });

    // get products
    builder.addCase(getAllProduct.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllProduct.fulfilled, (state, action) => {
      state.products = action.payload?.response;
      state.loading = false;
    });
    builder.addCase(getAllProduct.rejected, (state) => {
      state.loading = false;
    });

    // get seller products
    builder.addCase(getAllSellerProduct.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllSellerProduct.fulfilled, (state, action) => {
      state.products = action.payload?.response;
      state.loading = false;
    });
    builder.addCase(getAllSellerProduct.rejected, (state) => {
      state.loading = false;
    });

    // get single product
    builder.addCase(getSingleProduct.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSingleProduct.fulfilled, (state, action) => {
      state.singleProduct = action.payload?.response;
      state.productVariants = action.payload?.response?.productVariants || [];
      state.loading = false;
    });
    builder.addCase(getSingleProduct.rejected, (state) => {
      state.loading = false;
    });

    // upload products
    builder.addCase(uploadProduct.pending, (state) => {
      state.uploading = true;
    });
    builder.addCase(uploadProduct.fulfilled, (state, action) => {
      state.productResponse = action.payload?.response;
      state.singleProduct = action.payload?.response;
      state.productVariants = action.payload?.response?.productVariants || [];
      state.uploading = false;
    });
    builder.addCase(uploadProduct.rejected, (state) => {
      state.uploading = false;
    });

    // update products
    builder.addCase(updateProduct.pending, (state) => {
      state.uploading = true;
    });
    builder.addCase(updateProduct.fulfilled, (state, action) => {
      state.productResponse = action.payload?.response;
      state.uploading = false;
    });
    builder.addCase(updateProduct.rejected, (state) => {
      state.uploading = false;
    });

    // update products
    builder.addCase(deleteProduct.pending, (state) => {
      state.uploading = true;
    });
    builder.addCase(deleteProduct.fulfilled, (state, action) => {
      // state.productResponse = action.payload?.response;
      state.uploading = false;
    });
    builder.addCase(deleteProduct.rejected, (state) => {
      state.uploading = false;
    });

    // activate/disactivate products
    builder.addCase(activationProduct.pending, (state) => {
      state.uploading = true;
    });
    builder.addCase(activationProduct.fulfilled, (state, action) => {
      const updatedProduct = action.payload?.response || {};

      if (!Array.isArray(state.products?.content)) return;

      state.products.content = state.products.content.map((item) =>
        item.productId === updatedProduct.productId ? updatedProduct : item
      );

      state.uploading = false;
    });
    builder.addCase(activationProduct.rejected, (state) => {
      state.uploading = false;
    });

    // upload color
    builder.addCase(uploadColor.pending, (state) => {
      state.uploading = true;
    });
    builder.addCase(uploadColor.fulfilled, (state, action) => {
      state.colorResponse = action.payload?.response;
      state.uploading = false;
    });
    builder.addCase(uploadColor.rejected, (state) => {
      state.uploading = false;
    });

    // update color
    builder.addCase(updateColor.pending, (state) => {
      state.uploading = true;
    });
    builder.addCase(updateColor.fulfilled, (state, action) => {
      state.colorResponse = action.payload?.response;
      state.uploading = false;
    });
    builder.addCase(updateColor.rejected, (state) => {
      state.uploading = false;
    });

    // upload size
    builder.addCase(uploadSize.pending, (state) => {
      state.uploading = true;
    });
    builder.addCase(uploadSize.fulfilled, (state, action) => {
      state.sizeResponse = action.payload?.response;
      state.uploading = false;
    });
    builder.addCase(uploadSize.rejected, (state) => {
      state.uploading = false;
    });

    // update size
    builder.addCase(updateSize.pending, (state) => {
      state.uploading = true;
    });
    builder.addCase(updateSize.fulfilled, (state, action) => {
      state.sizeResponse = action.payload?.response;
      state.uploading = false;
    });
    builder.addCase(updateSize.rejected, (state) => {
      state.uploading = false;
    });
  },
});

export const {
  addKeywordSearch,
  addSku,
  addSortBy,
  addSortDir,
  clearAllFilter,
  setEditProduct,
  setStepper,
  setIsVideo,
  setCategoryType,
  setProductVariants,
} = productSlice.actions;
export default productSlice.reducer;
